import type { ProductPhoto as ProductPhotoAsset } from '@/lib/product-imagery';

export function ProductPhoto({ image }: { image: ProductPhotoAsset }) {
  const base = '/images/products/' + image.file;
  return <figure className="catalogue-photo">
    <img src={base + '-768.webp'} srcSet={`${base}-480.webp 480w, ${base}-768.webp 768w, ${base}-1536.webp 1536w`}
      sizes="(max-width: 600px) calc(100vw - 40px), (max-width: 860px) calc((100vw - 64px) / 2), (max-width: 900px) calc((100vw - 80px) / 2), (max-width: 1100px) calc((100vw - 324px) / 2), (min-width: 1392px) 329px, calc((100vw - 406px) / 3)"
      width={768} height={512} alt={image.alt} loading="lazy" decoding="async" />
    <figcaption>Illustrative image</figcaption>
  </figure>;
}
